import { EntityTypes } from './enums/entityTypes';
import { AvatarSizes } from './enums/avatarSizes';

export interface Avatar {
  avatarId?: string;
  orgId: string;
  entityType: EntityTypes.avatar;
  image: string;
  size: AvatarSizes;
  created: number;
  lastUpdated: number;
}
